/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Country_HintInputs */



/**
* | output |
* | --- |
* | "The community this link serves, not necessarily where you live." |
*
* @param {Community_Link_Country_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_country_hint = /** @type {((inputs?: Community_Link_Country_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Country_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La communauté que sert ce lien, pas forcément là où vous vivez.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La comunidad a la que sirve este enlace, no necesariamente donde vives.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A comunidade que este link atende, não necessariamente onde você mora.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La community a cui serve questo link, non per forza dove vivi.")
	return /** @type {LocalizedString} */ ("The community this link serves, not necessarily where you live.")
});